module.exports = __webpack_public_path__ + "img/montgolfiere.1da016b9.jpg";